import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout
      title="页面不存在 - 丝瓜视频"
      description="你访问的页面不存在或已被移除，可以回到丝瓜视频首页继续浏览影视内容。"
    >
      <main className="flex-1 w-full px-4 md:px-8 py-20 flex flex-col items-center text-center">
        <span className="font-heading text-6xl md:text-8xl font-black text-primary-200 select-none">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl md:text-3xl font-black text-foreground-950">
          这个页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">
          你访问的地址可能已经变更或被移除。回到首页，或者从分类频道继续找片。
        </p>
        <p className="mt-2 font-label text-xs text-foreground-400 break-all">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-5 h-11 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i> 返回首页
          </Link>
          <Link
            to="/search"
            className="px-5 h-11 inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line"></i> 去搜索影视
          </Link>
        </div>
      </main>
    </SiteLayout>
  );
}